import { React, useEffect, useState } from "react";
import { AuthWrapper } from "../components/AuthWrapper";
import { GoogleButton } from "../components/GoogleButton";
import { trackEvent } from "../helpers/tracking";
import { getReferral } from "../helpers/referral";

import {
  Box,
  Button,
  Center,
  Divider,
  FormControl,
  Input,
  Link,
  InputRightElement,
  InputLeftElement,
  InputGroup,
  InputRightAddon,
  InputLeftAddon,
  Image,
  Select,
} from "@chakra-ui/react";

import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";

import http from "../connection/connect";

import PhoneNumberInput from "../components/PhoneNumberComponent/PhoneNumberInput";
import { COUNTRIES } from "../components/PhoneNumberComponent/countries";
import logo from "../assets/animated-right-mark.gif";
import { withTranslation } from 'react-i18next';

const Register = (props) => {
  const { t, i18n } = props;
  const [isLoading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const lang = i18n.language;

  const countryOptions = COUNTRIES.map(({ name, iso }) => ({
    label: name,
    value: iso
  })).filter(({ value }) => value !== "ISR");

  //form state
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  // The store's display name (channel name, tab title). Until the merchant
  // edits the address by hand, the address follows it.
  const [storeName, setStoreName] = useState("");
  const [usernameEdited, setUsernameEdited] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [currency, setCurrency] = useState("");
  // const [language, setlanguage] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  //password and confirm password visibility states
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  //password and confirm password visibility functions
  const handleIconClick = () => setShowPassword(!showPassword);
  const handleConfirmIconClick = () =>
    setShowConfirmPassword(!showConfirmPassword);

  //password and confirmPassword match
  var isMatch = password !== confirmPassword;

  //error state
  const [err, setErr] = useState("");


  //form values
  // The admin and the store open in the language the merchant signed up in
  // (storkplus.com/en links here with ?lng=en). Before, it was never sent and
  // every store was created in Arabic.
  const language = String(i18n.language || "").toLowerCase().startsWith("ar") ? "ar" : "en";

  // Funnel: the signup form was seen (sign_up fires on success).
  useEffect(() => {
    trackEvent("sign_up_start", undefined, { language });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formValues = {
    name,
    email,
    username,
    storeName: storeName.trim() || undefined,
    phoneNumber,
    currency,
    language,
    password,
  };

  //form submit function
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isMatch) {
      setLoading(true);
      try {
        const response = await http.post("api/auth/register", {
          ...formValues,
          ...getReferral(),
        });

        if (response.data.status === 200) {
          trackEvent("sign_up", undefined, { language, currency: currency || "USD" });
          setLoading(false);
          setSuccess(true);
        } else {
          setLoading(false);
          setErr(response.data.message);
        }
      } catch (error) {
        setLoading(false);
        if (error.response) {
          setErr(error.response.data.message);
        } else {
          setErr("Something went wrong. Please try again later.");
        }
      }
    } else {
      setLoading(false);
      setErr(t('registerPage.passwordDoNotMatch')); // Set error message
    }
  };
  return (
    <>
      {
        success
          ? <AuthWrapper header={t('registerPage.createNewAccount')}>
            <Center>
              <Box boxSize="200px">
                <Image src={logo} alt="" />
              </Box>
            </Center>
            <Box textAlign="center" color="#b8bbd5" fontSize="0.95rem" lineHeight="1.8">
              {t('registerPage.successRegisterMessage')}
            </Box>
            <Center mt={6}>
              <Button
                type="submit"
                width="100%"
                onClick={() => {
                  window.location.href = "https://storkplus.com/";
                }}
              >
                {t('registerPage.backToHomepage')}
              </Button>
            </Center>
          </AuthWrapper>
          : <AuthWrapper
            header={t('registerPage.createNewAccount')}
            subtitle={t('registerPage.subtitle', 'Unlimited products and orders on the free plan. No credit card needed.')}
          >
            <GoogleButton source="register" />
            <form onSubmit={handleSubmit}>
              <FormControl mt={4}>
                <Input
                  id={"Name"}
                  placeholder={t('registerPage.name')}
                  type="text"
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  bg="rgba(255, 255, 255, 0.1)"
                  borderColor="rgba(255, 255, 255, 0.3)"
                  color="white"
                  _placeholder={{ color: "rgba(255, 255, 255, 0.6)" }}
                  _hover={{ borderColor: "rgba(255, 255, 255, 0.5)" }}
                  _focus={{
                    borderColor: "rgba(255, 255, 255, 0.8)",
                    bg: "rgba(255, 255, 255, 0.15)",
                    boxShadow: "0 0 0 1px rgba(255, 255, 255, 0.3)"
                  }}
                />

                <Input
                  id={"Email"}
                  mt={5}
                  placeholder={t('registerPage.email')}
                  type="email"
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  bg="rgba(255, 255, 255, 0.1)"
                  borderColor="rgba(255, 255, 255, 0.3)"
                  color="white"
                  _placeholder={{ color: "rgba(255, 255, 255, 0.6)" }}
                  _hover={{ borderColor: "rgba(255, 255, 255, 0.5)" }}
                  _focus={{
                    borderColor: "rgba(255, 255, 255, 0.8)",
                    bg: "rgba(255, 255, 255, 0.15)",
                    boxShadow: "0 0 0 1px rgba(255, 255, 255, 0.3)"
                  }}
                />

                <PhoneNumberInput
                  mt={5}
                  country={"EGY"}
                  value={phoneNumber}
                  options={countryOptions}
                  lang={lang}
                  placeholder={t('registerPage.phoneNumber')}
                  onChange={(phoneNumber) => setPhoneNumber(phoneNumber)}
                />

                <Select
                  id={"Currency"}
                  onChange={(e) => {
                    setCurrency(e.target.value);
                  }}
                  placeholder={t("registerPage.selectCurrency")}
                  mt={5}
                  bg="rgba(255, 255, 255, 0.1)"
                  borderColor="rgba(255, 255, 255, 0.3)"
                  color="white"
                  _placeholder={{ color: "rgba(255, 255, 255, 0.6)" }}
                  _hover={{ borderColor: "rgba(255, 255, 255, 0.5)" }}
                  _focus={{
                    borderColor: "rgba(255, 255, 255, 0.8)",
                    bg: "rgba(255, 255, 255, 0.15)",
                    boxShadow: "0 0 0 1px rgba(255, 255, 255, 0.3)"
                  }}
                  sx={{
                    paddingLeft: "1rem",
                    paddingRight: "2rem",
                    option: {
                      bg: "#001756",
                      color: "white"
                    }
                  }}
                >
                  <option key="SAR" value='SAR'>{t('registerPage.SAR')}</option>
                  <option key="USD" value='USD'>{t('registerPage.USD')}</option>
                  <option key="EGP" value='EGP'>{t('registerPage.EGP')}</option>
                  <option key="EUR" value='EUR'>{t('registerPage.EUR')}</option>
                </Select>


                {/*<Select
                    id={"Language"}
                    onChange={(e) => {
                      setlanguage(e.target.value);
                    }}
                    placeholder={t("registerPage.selectLanguage")}
                    mt={5}
                    sx={{
                      paddingLeft: "1rem",
                      paddingRight: "2rem",
                    }}
                >
                  <option key="AR" value='ar'>{t('registerPage.AR')}</option>
                  <option key="EN" value='en'>{t('registerPage.EN')}</option>
                </Select>*/}

                <Input
                  id={"StoreName"}
                  mt={5}
                  placeholder={t('registerPage.storeName', 'Store name')}
                  type="text"
                  maxLength={80}
                  value={storeName}
                  onChange={(e) => {
                    const value = e.target.value;
                    setStoreName(value);
                    if (!usernameEdited) {
                      setUsername(value.toLowerCase().replace(/[^a-z0-9]/g, "").slice(0, 40));
                    }
                  }}
                  bg="rgba(255, 255, 255, 0.1)"
                  borderColor="rgba(255, 255, 255, 0.3)"
                  color="white"
                  _placeholder={{ color: "rgba(255, 255, 255, 0.6)" }}
                  _hover={{ borderColor: "rgba(255, 255, 255, 0.5)" }}
                  _focus={{
                    borderColor: "rgba(255, 255, 255, 0.8)",
                    bg: "rgba(255, 255, 255, 0.15)",
                    boxShadow: "0 0 0 1px rgba(255, 255, 255, 0.3)"
                  }}
                />

                <Box mt={5}>
                  <Box mb={2} fontSize="0.85rem" fontWeight="600" color="#e4e7fd">
                    {t('registerPage.storeAddress')}
                  </Box>
                  <Box dir="ltr">
                    <InputGroup>
                    <InputLeftAddon
                      bg="rgba(255, 255, 255, 0.1)"
                      borderColor="rgba(255, 255, 255, 0.3)"
                      color="white"
                    >
                      https://
                    </InputLeftAddon>
                    <Input
                      id={"Username"}
                      placeholder={t('registerPage.username')}
                      type="text"
                      value={username}
                      autoCapitalize="none"
                      autoCorrect="off"
                      spellCheck={false}
                      // The username is the store's subdomain: browsers
                      // lowercase hostnames, so it is lowercased as typed and
                      // anything a hostname label cannot hold is dropped.
                      onChange={(e) => {
                        setUsernameEdited(true);
                        setUsername(
                          e.target.value.toLowerCase().replace(/[^a-z0-9]/g, "")
                        );
                      }}
                      bg="rgba(255, 255, 255, 0.1)"
                      borderColor="rgba(255, 255, 255, 0.3)"
                      color="white"
                      _placeholder={{ color: "rgba(255, 255, 255, 0.6)" }}
                      _hover={{ borderColor: "rgba(255, 255, 255, 0.5)" }}
                      _focus={{
                        borderColor: "rgba(255, 255, 255, 0.8)",
                        bg: "rgba(255, 255, 255, 0.15)",
                        boxShadow: "0 0 0 1px rgba(255, 255, 255, 0.3)"
                      }}
                    />
                      <InputRightAddon
                        bg="rgba(255, 255, 255, 0.1)"
                        borderColor="rgba(255, 255, 255, 0.3)"
                        color="white"
                      >
                        {process.env.REACT_APP_STORAK_PLUS_URL}
                      </InputRightAddon>
                    </InputGroup>
                  </Box>
                  <Box mt={2} fontSize="0.78rem" color="#b8bbd5">
                    {t('registerPage.storeAddressHint')}
                  </Box>
                </Box>

                <InputGroup mt={5}>
                  <Input
                    id={"Password"}
                    placeholder={t('registerPage.password')}
                    type={showPassword ? "text" : "password"}
                    style={{ paddingInlineStart: '14px' }}
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                    bg="rgba(255, 255, 255, 0.1)"
                    borderColor="rgba(255, 255, 255, 0.3)"
                    color="white"
                    _placeholder={{ color: "rgba(255, 255, 255, 0.6)" }}
                    _hover={{ borderColor: "rgba(255, 255, 255, 0.5)" }}
                    _focus={{
                      borderColor: "rgba(255, 255, 255, 0.8)",
                      bg: "rgba(255, 255, 255, 0.15)",
                      boxShadow: "0 0 0 1px rgba(255, 255, 255, 0.3)"
                    }}
                  />
                  {lang === 'ar' ?
                    <InputLeftElement
                      children={
                        showPassword ? (
                          <ViewOffIcon
                            onClick={() => {
                              handleIconClick();
                            }}
                            color="white"
                            cursor="pointer"
                          />
                        ) : (
                          <ViewIcon
                            onClick={() => {
                              handleIconClick();
                            }}
                            color="white"
                            cursor="pointer"
                          />
                        )
                      }
                    />
                    :
                    <InputRightElement
                      children={
                        showPassword ? (
                          <ViewOffIcon
                            onClick={() => {
                              handleIconClick();
                            }}
                            color="white"
                            cursor="pointer"
                          />
                        ) : (
                          <ViewIcon
                            onClick={() => {
                              handleIconClick();
                            }}
                            color="white"
                            cursor="pointer"
                          />
                        )
                      }
                    />
                  }
                </InputGroup>

                <InputGroup mt={5}>
                  <Input
                    id={"ConfirmPassword"}
                    placeholder={t('registerPage.confirmPassword')}
                    type={showConfirmPassword ? "text" : "password"}
                    style={{ paddingInlineStart: '14px' }}
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                    }}
                    bg="rgba(255, 255, 255, 0.1)"
                    borderColor="rgba(255, 255, 255, 0.3)"
                    color="white"
                    _placeholder={{ color: "rgba(255, 255, 255, 0.6)" }}
                    _hover={{ borderColor: "rgba(255, 255, 255, 0.5)" }}
                    _focus={{
                      borderColor: "rgba(255, 255, 255, 0.8)",
                      bg: "rgba(255, 255, 255, 0.15)",
                      boxShadow: "0 0 0 1px rgba(255, 255, 255, 0.3)"
                    }}
                  />
                  {
                    i18n.language === 'ar' ?
                      <InputLeftElement
                        children={
                          showConfirmPassword ? (
                            <ViewOffIcon
                              onClick={() => {
                                handleConfirmIconClick();
                              }}
                              color="white"
                              cursor="pointer"
                            />
                          ) : (
                            <ViewIcon
                              onClick={() => {
                                handleConfirmIconClick();
                              }}
                              color="white"
                              cursor="pointer"
                            />
                          )
                        }
                      />
                      :
                      <InputRightElement
                        children={
                          showConfirmPassword ? (
                            <ViewOffIcon
                              onClick={() => {
                                handleConfirmIconClick();
                              }}
                              color="white"
                              cursor="pointer"
                            />
                          ) : (
                            <ViewIcon
                              onClick={() => {
                                handleConfirmIconClick();
                              }}
                              color="white"
                              cursor="pointer"
                            />
                          )
                        }
                      />
                  }
                </InputGroup>

                <Box mb={3} color="rgba(252, 165, 165, 1)" fontWeight="500">
                  {isMatch ? t('registerPage.passwordDoNotMatch') : null}
                </Box>

                <Center>
                  <Button
                    isLoading={isLoading}
                    loadingText={t('registerPage.register')}
                    type="submit"
                    width="100%"
                    height="3.5rem"
                    fontSize="lg"
                    fontWeight="bold"
                    bg="white"
                    color="#001756"
                    _hover={{ bg: "rgba(255, 255, 255, 0.9)" }}
                    _active={{ bg: "rgba(255, 255, 255, 0.8)" }}
                    onClick={(e) => {
                      e.preventDefault();
                      handleSubmit(e);
                    }}
                  >
                    {t('registerPage.register')}
                  </Button>
                </Center>
                <Center>
                  {typeof err === "string" && err ? (
                    <Box
                      color="white"
                      mt={3}
                      bg="rgba(220, 38, 38, 0.15)"
                      borderColor="rgba(220, 38, 38, 0.5)"
                      borderWidth="1px"
                      borderRadius="md"
                      p={3}
                    >
                      {err}
                    </Box>
                  ) : (
                    err.length > 0 && (
                      <Box
                        color="white"
                        mt={3}
                        textAlign="center"
                        bg="rgba(220, 38, 38, 0.15)"
                        borderColor="rgba(220, 38, 38, 0.5)"
                        borderWidth="1px"
                        borderRadius="md"
                        p={3}
                      >
                        {err.map((error, index) => {
                          return <p key={index}>{error}</p>;
                        })}
                      </Box>
                    )
                  )}
                </Center>
                <Center mt={3}>
                  <Link href="/login" textAlign="center" color="white" _hover={{ color: "rgba(255, 255, 255, 0.8)", textDecoration: "underline" }}>
                    {t('registerPage.haveAnAccount')}
                  </Link>
                </Center>
              </FormControl>
            </form>
          </AuthWrapper>
      }
    </>
  );
};

export default withTranslation()(Register);
